import integration from './integration';
import variable from './variable';
import url from './url';

const conditionals = { integration, variable, url };

export default conditionals;
